import { observer } from 'mobx-react-lite';
import { useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { useStore } from '../../app/stores/store';
import LoadingComponent from '../../app/layout/LoadingComponent';
import { Message, Segment } from 'semantic-ui-react';

function MovementGate() {
  const { activityStore } = useStore();
  const { trackgatemessage, trackGate } = activityStore;
  const { id, gate, direction } = useParams<{
    id: string;
    gate: string;
    direction: string;
  }>();

  useEffect(() => {
    if (id && gate && direction) {
      trackGate(id, gate, direction);
    }
    // eslint-disable-next-line
  }, [id, gate, direction]);
  if (trackgatemessage === '') return <LoadingComponent />;
  const messages = trackgatemessage === 'Asset not found !!!' ? 'red' : 'green';
  return (
    <Segment>
      <Message color={messages}>
        <Message.Header>Status</Message.Header>
        <p style={{ color: 'black' }}>Track message - {trackgatemessage}</p>
      </Message>
    </Segment>
  );
}

export default observer(MovementGate);
